import { BridgeComponent } from "@hotwired/strada"
import { Modal } from "bootstrap"

export default class extends BridgeComponent {
  static component = "comments-button"
  static targets = ["trigger"]
  static values = { commentsCount: Number, modalId: String }

  connect() {
    super.connect()
    this.prepareModal()
    window.__depozenOpenComments = (modalId) => this.openCommentsModal(modalId)
    this.onBridgeReady = () => this.notifyBridge()
    document.addEventListener("web-bridge:ready", this.onBridgeReady)
  }

  disconnect() {
    document.removeEventListener("web-bridge:ready", this.onBridgeReady)
    delete window.__depozenOpenComments
    super.disconnect()
  }

  triggerTargetConnected() {
    this.notifyBridge()
  }

  get resolvedModalId() {
    if (this.modalIdValue) return this.modalIdValue

    const attributeNames = [
      "data-bridge-comments-button-modal-id-value",
      "data-bridge--comments-button-modal-id-value"
    ]

    for (const attributeName of attributeNames) {
      const value = this.element.getAttribute(attributeName)
      if (value) return value
    }

    const trigger = this.hasTriggerTarget ? this.triggerTarget : null
    const target = trigger?.querySelector("[data-bs-target]")?.getAttribute("data-bs-target")
      || trigger?.getAttribute("data-bs-target")

    return target?.replace(/^#/, "") || ""
  }

  notifyBridge() {
    if (!this.enabled) return

    const modalId = this.resolvedModalId
    if (!modalId) return

    this.send("connect", {
      commentsCount: this.commentsCountValue,
      modalId
    }, () => {
      this.openCommentsModal(modalId)
    })

    document.dispatchEvent(new CustomEvent("depozen:register-native-overflow"))
  }

  prepareModal(modalId = this.resolvedModalId) {
    if (!modalId) return

    const panel = document.getElementById(modalId)
    if (panel && panel.parentElement !== document.body) {
      document.body.appendChild(panel)
    }
  }

  openCommentsModal(modalId) {
    const id = modalId || this.resolvedModalId
    if (!id) return

    this.prepareModal(id)

    const panel = document.getElementById(id)
    if (!panel) {
      document.getElementById(`${id}-button`)?.click()
      return
    }

    Modal.getOrCreateInstance(panel).show()
  }
}
